"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotiDTO = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const GameConst_1 = require("../constants/GameConst");
class NotiDTO {
    static fromJson(data) {
        const startedAt = moment_timezone_1.default.tz(data['started_at'], 'Asia/Tokyo').format();
        // Calculate diff time for NEW label
        let isNew = true;
        const now = new Date();
        const startDate = new Date(startedAt);
        const diffTimeInSecond = (now.getTime() - startDate.getTime()) / 1000;
        // Delete NEW mark after 3 days of release
        const secondsInDay = 86400;
        if (diffTimeInSecond >= secondsInDay * GameConst_1.DAYS_CONDITION) {
            isNew = false;
        }
        return {
            id: data['notice_id'],
            title: data['title'],
            categoryId: data['category_id'],
            categoryEnName: data['category_en_name'],
            categoryJaName: data['category_ja_name'],
            typeId: data['type_id'],
            typeEnName: data['type_en_name'],
            typeJaName: data['type_ja_name'],
            startedAt: new Date(startedAt),
            unread: data['unread'],
            body: null,
            isNew,
        };
    }
}
exports.NotiDTO = NotiDTO;
